import { Injectable } from '@angular/core';
export class ConfigService {
    title = 'Config Service';
private configured: boolean;
private config: any;
constructor() {
        this.configured = false;
        this.config = {};

        this.config.environment = 'prod';
        
                if(this.config.environment == 'dev'){
                    this.config.baseUrl = 'http://localhost:8081';
                    this.config.awsBucket = 'https://s3.amazonaws.com/apgv-public-read-test/';
                    this.config.stripe_client_id = 'ca_AgzFzaM6jReqtcRYjy86zpVsmYddJ400';
                    this.config.stripe_publishable_key = 'pk_test_KB93PVnmMqX5CuBDWEGqp9J7';
                } else if (this.config.environment == 'dev-products2'){
                    this.config.baseUrl = 'http://localhost:8081';
                    this.config.awsBucket = 'https://s3.amazonaws.com/apgv-public-read-test/';
                    this.config.stripe_client_id = 'ca_AgzFzaM6jReqtcRYjy86zpVsmYddJ400';
                    this.config.stripe_publishable_key = 'pk_test_KB93PVnmMqX5CuBDWEGqp9J7';
                } else if (this.config.environment == 'prod'){
                    this.config.baseUrl = 'https://api.22ndtech.com';
                    this.config.awsBucket = 'https://s3.amazonaws.com/apgv-public-read/';
                    this.config.stripe_client_id = 'ca_AgzFzznyEF0PpUzmNR5mlb6YET9KT0XX';
                    this.config.stripe_publishable_key = 'pk_live_TuR1rro0ZsXpoW1xeRTjMHmY';
                }

        this.configured = true;
    }
/**
 * @param {?} callback
 * @param {?=} configPath
 * @param {?=} initializationTime
 * @return {?}
 */
getConfig(callback: any, configPath = '', initializationTime = 0): any {
        if (this.configured) {
            if (configPath) {
                callback(this.config);
            } else {
                callback(this.config);
            }
        } else {
            setTimeout(this.getConfig, 500, configPath, callback, initializationTime ? initializationTime : Date.now());
        }

    }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ConfigService_tsickle_Closure_declarations() {
/** @type {?} */
ConfigService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfigService.ctorParameters;
/** @type {?} */
ConfigService.prototype.title;
/** @type {?} */
ConfigService.prototype.configured;
/** @type {?} */
ConfigService.prototype.config;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
